 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","i18n.common":"i18n.common","i18n.common.az":"i18n.common.az","i18n.common.bn":"i18n.common.bn","i18n.common.es":"i18n.common.es","i18n.common.fr":"i18n.common.fr","i18n.common.hr":"i18n.common.hr","i18n.common.kk":"i18n.common.kk","i18n.common.pt":"i18n.common.pt","i18n.common.ro":"i18n.common.ro","i18n.common.ru":"i18n.common.ru","i18n.common.sr-Latn":"i18n.common.sr-Latn","i18n.common.uz":"i18n.common.uz","i18n.translation0":"i18n.translation0","i18n.translation1":"i18n.translation1","i18n.translation10":"i18n.translation10","i18n.translation11":"i18n.translation11","i18n.translation12":"i18n.translation12","i18n.translation13":"i18n.translation13","i18n.translation2":"i18n.translation2","i18n.translation3":"i18n.translation3","i18n.translation4":"i18n.translation4","i18n.translation5":"i18n.translation5","i18n.translation6":"i18n.translation6","i18n.translation7":"i18n.translation7","i18n.translation8":"i18n.translation8","i18n.translation9":"i18n.translation9"}[chunkId]||chunkId) + "-legacy." + {"chunk-03225eb5":"ee2a779d","chunk-04e03cf3":"eb4ce28d","chunk-20272373":"a7db29d3","chunk-dfe7d13a":"1ebe8a3b","chunk-1289330d":"84066824","chunk-545e32c6":"0c06a415","chunk-85d23624":"90b1d503","chunk-155210cd":"629c0cdf","chunk-6cb7dc60":"073845dc","home":"d335eebd","i18n.common":"3ef80866","i18n.common.az":"e2d85f13","i18n.common.bn":"b781e208","i18n.common.es":"2557f7e0","i18n.common.fr":"74ddc5e3","i18n.common.hr":"0a9ae171","i18n.common.kk":"a79bc017","i18n.common.pt":"3a034142","i18n.common.ro":"75dedd43","i18n.common.ru":"3012c852","i18n.common.sr-Latn":"5617b731","i18n.common.uz":"408116bb","chunk-22e0b5cf":"fc73c179","chunk-3df1374a":"eecb0754","chunk-78999045":"8f1a852e","i18n.translation0":"dbb1a9f9","i18n.translation1":"6b03b249","i18n.translation10":"62bddcc9","i18n.translation11":"4fe319f2","i18n.translation12":"b4a5a16a","i18n.translation13":"91144a73","i18n.translation2":"32a4ee82","i18n.translation3":"d9a7bc1c","i18n.translation4":"652aac7c","i18n.translation5":"7e80697d","i18n.translation6":"d0a8f75c","i18n.translation7":"90f700ef","i18n.translation8":"10e37693","i18n.translation9":"220277e6","chunk-52326c7b":"00aee075","chunk-5b03fbdb":"8fac2348","chunk-6c2bde24":"086af830","chunk-7415c278":"ac1740d5","chunk-6af8e4de":"317ee95d","chunk-fbcd0da8":"2d6efebe","chunk-c48bcc4c":"fa506974"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03225eb5":1,"chunk-85d23624":1,"chunk-155210cd":1,"chunk-22e0b5cf":1,"chunk-3df1374a":1,"chunk-78999045":1,"chunk-52326c7b":1,"chunk-5b03fbdb":1,"chunk-6c2bde24":1,"chunk-7415c278":1,"chunk-6af8e4de":1,"chunk-fbcd0da8":1,"chunk-c48bcc4c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","i18n.common":"i18n.common","i18n.common.az":"i18n.common.az","i18n.common.bn":"i18n.common.bn","i18n.common.es":"i18n.common.es","i18n.common.fr":"i18n.common.fr","i18n.common.hr":"i18n.common.hr","i18n.common.kk":"i18n.common.kk","i18n.common.pt":"i18n.common.pt","i18n.common.ro":"i18n.common.ro","i18n.common.ru":"i18n.common.ru","i18n.common.sr-Latn":"i18n.common.sr-Latn","i18n.common.uz":"i18n.common.uz","i18n.translation0":"i18n.translation0","i18n.translation1":"i18n.translation1","i18n.translation10":"i18n.translation10","i18n.translation11":"i18n.translation11","i18n.translation12":"i18n.translation12","i18n.translation13":"i18n.translation13","i18n.translation2":"i18n.translation2","i18n.translation3":"i18n.translation3","i18n.translation4":"i18n.translation4","i18n.translation5":"i18n.translation5","i18n.translation6":"i18n.translation6","i18n.translation7":"i18n.translation7","i18n.translation8":"i18n.translation8","i18n.translation9":"i18n.translation9"}[chunkId]||chunkId) + "." + {"chunk-03225eb5":"742e9f80","chunk-04e03cf3":"31d6cfe0","chunk-20272373":"31d6cfe0","chunk-dfe7d13a":"31d6cfe0","chunk-1289330d":"31d6cfe0","chunk-545e32c6":"31d6cfe0","chunk-85d23624":"4cecf80c","chunk-155210cd":"e313b1b1","chunk-6cb7dc60":"31d6cfe0","home":"31d6cfe0","i18n.common":"31d6cfe0","i18n.common.az":"31d6cfe0","i18n.common.bn":"31d6cfe0","i18n.common.es":"31d6cfe0","i18n.common.fr":"31d6cfe0","i18n.common.hr":"31d6cfe0","i18n.common.kk":"31d6cfe0","i18n.common.pt":"31d6cfe0","i18n.common.ro":"31d6cfe0","i18n.common.ru":"31d6cfe0","i18n.common.sr-Latn":"31d6cfe0","i18n.common.uz":"31d6cfe0","chunk-22e0b5cf":"4b92ddb4","chunk-3df1374a":"01cf6820","chunk-78999045":"1a3f05c1","i18n.translation0":"31d6cfe0","i18n.translation1":"31d6cfe0","i18n.translation10":"31d6cfe0","i18n.translation11":"31d6cfe0","i18n.translation12":"31d6cfe0","i18n.translation13":"31d6cfe0","i18n.translation2":"31d6cfe0","i18n.translation3":"31d6cfe0","i18n.translation4":"31d6cfe0","i18n.translation5":"31d6cfe0","i18n.translation6":"31d6cfe0","i18n.translation7":"31d6cfe0","i18n.translation8":"31d6cfe0","i18n.translation9":"31d6cfe0","chunk-52326c7b":"f9a51878","chunk-5b03fbdb":"ab1fb76f","chunk-6c2bde24":"1d044194","chunk-7415c278":"59759139","chunk-6af8e4de":"788b10b5","chunk-fbcd0da8":"11f3a65c","chunk-c48bcc4c":"901c5338"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
